import React, { FunctionComponent, ReactNode } from 'react';
import { AccordionPanel, Box } from '@chakra-ui/react';

interface StepperContentProps {
  children: ReactNode;
}

export const StepperContent: FunctionComponent<StepperContentProps> = ({ children }) => (
  <AccordionPanel p={0}>
    <Box className={`md:px-6`}>{children}</Box>
  </AccordionPanel>
);
